<template>
  <div>
    <button
      v-b-modal.addLocalisedOrValues
      v-b-tooltip.hover
      class="btn btn-success float-right actionButton"
      placement="bottom"
      title="Ortsbaum mit Mehrfachauswahl hinzufügen"
      type="button"
      @click="
        criteriaToAddOrCandidatesIndex = index;
        showModal('addLocalisedOrValues');
      "
    >
      <i class="fas fa-map-marker" />
    </button>
    <b-modal
      id="addLocalisedOrValues"
      ref="addLocalisedOrValues"
      class="w-100"
      hide-footer
      no-fade
      scrollable
      size="lg"
      title="Lokalisierte Werte mit OR hinzufügen"
    >
      <div class="d-block mb-4">
        Fügen sie neue Lokalisierte Filter hinzu, die mit OR verknüpft sind.
        Dadurch werden neue Filtergruppen erstellt. Die Änderungen müssen dann
        noch mit dem Button 'Speichern' bestätigt werden. Die Änderungen können
        auch mit dem Button 'Abbrechen' verworfen werden.
      </div>
      <b-row>
        <b-col
          cols="10"
          class="d-flex ml-4"
        >
          <criteria-groups-filter
            v-model="localisedOrCandidates"
            :contract-id="contractId"
            :version-id="versionId"
            :edition-id="editionId"
            :group-value-item-index="0"
            :limit-tree-selection-by-operator="false"
          />
        </b-col>
      </b-row>
      <div class="d-block my-4">
        Hier können den Gruppen weitere Filter hinzugefügt werden. Diese Filter werden bei jeder Gruppe vorhanden sein, die angelegt werden.
      </div>
      <b-row
        v-for="(filter, filterIndex) in additionalFilters"
        :key="filter.id + '_' + filterIndex"
        class="d-flex"
      >
        <b-col
          cols="10"
          class="d-flex ml-4"
        >
          <criteria-groups-filter
            v-model="additionalFilters[filterIndex]"
            :contract-id="contractId"
            :edition-id="editionId"
            :readonly="false"
            :version-id="versionId"
          />        
        </b-col>

        <b-col
          cols="1"
          class="d-flex align-items-center"
        >
          <button
            v-b-tooltip.hover
            class="btn btn-danger"
            placement="bottom"
            title="Diesen Filter löschen"
            type="button"
            @click="
              removeListItem(additionalFilters, filterIndex)
            "
          >
            <i class="fas fa-trash-alt" />
          </button>
        </b-col>
      </b-row>
      <b-row
        class="ml-4"
      >
        <button
          v-b-tooltip.hover
          class="btn btn-success smallActionButton mt-2"
          placement="bottom"
          title="Neuer Filter hinzufügen"
          type="button"
          @click="addNewFilterItem(additionalFilters)"
        >
          <i class="fas fa-plus" />
        </button>
      </b-row>
      <b-row class="mt-4 ml-4">
        <b-button
          variant="success"
          @click="addNewMultiLocationTree"
        >
          Hinzufügen
        </b-button>
        <b-button
          class="ml-2"
          variant="danger"
          @click="hideModal('addLocalisedOrValues')"
        >
          Abbrechen
        </b-button>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import CriteriaGroupsFilter from "@/components/minimum.wage/pages/CriteriaGroups/CriteriaGroupsFilter.vue";

export default {
  name: 'CriteriaAddLocalisedOrValues',
  components: {
    CriteriaGroupsFilter,
  },
  props: {
    contractId: {
      type: String,
      default: "",
    },
    versionId: {
      type: Number,
      default: 0,
    },
    editionId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      localisedOrCandidates: [],
      additionalFilters: [],
    }
  },
  created() {
    this.initialise();
  },
  methods: {
    initialise(){
      this.localisedOrCandidates = [];
      this.additionalFilters = [];
    },
    addNewMultiLocationTree() {
      let selectedPaths = this.localisedOrCandidates.value.split(";");
      let newFilterGroups = [];
      selectedPaths.map((path) => {
        var newItemGroup = {
          name: "",
          filters: [],
        };

        newItemGroup.filters.push({
          ...this.localisedOrCandidates,
          value: path,
        });

        this.additionalFilters.forEach((filter) => {
          newItemGroup.filters.push(filter);
        });

        newFilterGroups.push(newItemGroup);
      });

      this.$emit("added", newFilterGroups);
      this.hideModal("addLocalisedOrValues");
    },
    addNewFilterItem(list) {
      list.push({
        id: 0,
        operator: 1,
        criteriaStructureId: -1,
        value: "",
        order: 0,
      });
    },
    removeListItem(collection, index) {
      collection.splice(index, 1);
      this.$store.commit("setCriteria", this.items);
    },
    showModal(modalId) {
      this.initialise();
      this.$emit("opened");
      this.$refs[modalId].show();
    },
    hideModal(modalRef) {
      if (this.$refs[modalRef]) {
        this.$refs[modalRef].hide();
      }
    },
  }
}
</script>
